const TRUE = 'true';
const FALSE = 'false';
const PX = 'px';
const ARIA_CONTROLS = 'aria-controls';
const ARIA_DISABLED = 'aria-disabled';
const ARIA_EXPANDED = 'aria-expanded';
/**
 * Class representing an accordion
 * @see {@link https://w3c.github.io/aria-practices/#accordion}
 */
export default class Accordion {
    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        Object.defineProperty(this, "element", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "target", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const controls = element.getAttribute(ARIA_CONTROLS);
        this.element = element;
        this.target = controls
            ? document.getElementById(controls)
            : element.nextElementSibling;
        this.element.onclick = this.toggle.bind(this);
    }
    toggle() {
        if (this.element.getAttribute(ARIA_DISABLED) === TRUE)
            return;
        if (this.element.getAttribute(ARIA_EXPANDED) === FALSE)
            this.open();
        else
            this.close();
    }
    open() {
        this.element.setAttribute(ARIA_EXPANDED, TRUE);
        this.target.style.maxHeight = this.target.scrollHeight + PX;
    }
    close() {
        this.element.setAttribute(ARIA_EXPANDED, FALSE);
        this.target.style.maxHeight = '';
    }
}
